<template>
  <div>
    <c-q-btn
      v-if="showEditButton"
      id="btn-edit-institutional"
      propBtnLabel="Editar"
      :propBtnFunction="isApprovedOrReapproved ? abreDialogo : onEditInstitutional"
      :propBtnTransparent="true"
      :propBtnSize="props.propBtnSize"
    />

    <ModalConfirmationDialog
      propDialogTitle="Atenção!"
      propConfirmationMsg="Este cadastro já foi aprovado. Ao editar, será necessário enviar novamente para aprovação. Deseja continuar?"
      propDialogType="editar"
      @confirm="onEditInstitutional"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRouter } from 'vue-router'

import ModalConfirmationDialog from '@/views/modals/ModalConfirmationDialog.vue'

import { EnumButtonSizes, EnumRouteNames } from '@/enums/enums'

import { useInstitutionalStore } from '@/stores/institutionalStore'
import { usePagesUtilStore } from '@/stores/pagesUtilStore'
import { useAuthStore } from '@/stores/authStore'

import { CONST_INSTITUTIONAL_STATUS } from '@/static/constantsInstitutional'
import messages from '@/utils/messages'

const institutionalStore = useInstitutionalStore()
const pagesUtilStore = usePagesUtilStore()
const authStore = useAuthStore()
const router = useRouter()

const props = defineProps({
  propBtnSize: {
    type: String as () => keyof typeof EnumButtonSizes,
    default: EnumButtonSizes.LARGE_1
  }
})

const status = computed(() => institutionalStore.institutionalDetail?.status)

// ✅ mesmos status que campanhas
const showEditButton = computed(() => {
  return (
    authStore.currentUserCanEditInstitutional &&
    !!status.value &&
    [
      CONST_INSTITUTIONAL_STATUS.DRAFT.id,
      CONST_INSTITUTIONAL_STATUS.ON_EDITING.id,
      CONST_INSTITUTIONAL_STATUS.ADJUSTMENT_REQUESTED.id,
      CONST_INSTITUTIONAL_STATUS.ADJUSTMENT_REQUESTED_AGAIN.id,
      CONST_INSTITUTIONAL_STATUS.ON_REISSUE.id,
      CONST_INSTITUTIONAL_STATUS.APPROVED.id,
      CONST_INSTITUTIONAL_STATUS.REAPPROVED.id,
      CONST_INSTITUTIONAL_STATUS.PUBLISHED.id,
      CONST_INSTITUTIONAL_STATUS.PENDING_PUBLICATION.id,
      CONST_INSTITUTIONAL_STATUS.ACTIVE_INSTITUTIONAL.id
    ].includes(status.value)
  )
})

// ✅ abre modal de confirmação se aprovado/reaprovado
const isApprovedOrReapproved = computed(() =>
  status.value === CONST_INSTITUTIONAL_STATUS.APPROVED.id ||
  status.value === CONST_INSTITUTIONAL_STATUS.REAPPROVED.id
)

const abreDialogo = () => {
  pagesUtilStore.showModalConfirmationEditCampaign = true
}

const onEditInstitutional = async () => {
  try {
    const id = institutionalStore.institutionalDetail?.id
    if (!id) return

    pagesUtilStore.showLoading = true

    // ✅ só chama endpoint de edição se não estiver já em edição/reedição
    if (
      status.value !== CONST_INSTITUTIONAL_STATUS.ON_EDITING.id &&
      status.value !== CONST_INSTITUTIONAL_STATUS.ON_REISSUE.id
    ) {
      await institutionalStore.editInstitutional()
    }

    router.push({
      name: EnumRouteNames.INSTITUTIONAL_EDIT,
      params: { id }
    })

  } catch (error) {
    messages.showErrorMsg('Erro ao tentar abrir o cadastro para edição.')
  } finally {
    pagesUtilStore.showLoading = false
  }
}
</script>

<style scoped></style>
